import { getInterestMeta } from "./interest.utils";

/**
 * ======================================================
 * COMPOSANT ICONE D'INTERET
 * ======================================================
 */

export function InterestIcon({ interestId, className = "", ariaHidden = true }) {
  const interest = getInterestMeta(interestId);

  return (
    <span className={className} aria-hidden={ariaHidden}>
      {interest.emoji}
    </span>
  );
}
